export const siteInfo = {
  name: "Glazerocks RMC",

  address:
    "Office No. 206 & 207, Sonigara Landmark, Chatrapati Chowk, Dynasty Society, Kaspate Wasti, Wakad, Pimpri Chinchwad, Pune - 411057",

  phone: "+919999999999",
  email: "info@glazerocksrmc.com",

  mapEmbed:
    "https://maps.google.com/maps?q=Sonigara%20Landmark%20Wakad%20Pune&t=&z=15&ie=UTF8&iwloc=&output=embed",
};

export const plants = [
  {
    id: 1,
    name: "Wakad Plant",
    address: "Sonigara Landmark, Chatrapati Chowk",
    location: "Wakad, Pimpri Chinchwad, Pune - 411057",
    phone: "+919999999999",
    email: "info@glazerocksrmc.com",
    map:
      "https://maps.google.com/maps?q=Sonigara%20Landmark%20Wakad%20Pune&t=&z=15&ie=UTF8&iwloc=&output=embed",
  },
  {
    id: 2,
    name: "Fremont Plant",
    address: "789 Innovation Drive",
    location: "Fremont, California, USA - 94538",
    phone: "+019876543210",
    email: "company@gmail.com",
    map:
      "https://maps.google.com/maps?q=Fremont%20California&t=&z=13&ie=UTF8&iwloc=&output=embed",
  },
];